var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'single-collection-path',
{   'last': _vm.isLastItem,
    'halfWatched': _vm.isCourseHalfWatched,
    'completed': _vm.isCourseCompleted,
    'not-logged': !_vm.isLoggedIn }
]},[_c('span',{staticClass:"single-collection-path__circle"},[_vm._v(" "+_vm._s(_vm.index + 1))])])}
var staticRenderFns = []

export { render, staticRenderFns }